import React, { Fragment } from 'react';
export default function GridSummary(_, _ref) {
  var getItems = _ref.getItems;
  return {
    Component: 'div',
    className: 'jmtp-grid-summary',
    cardProps: function cardProps() {
      return {
        className: 'jmtp-grid-summary-card'
      };
    },
    getProps: function getProps(data) {
      return {
        children: getItems(data).map(function (item, index) {
          return /*#__PURE__*/React.createElement(Fragment, {
            key: index
          }, item.children);
        })
      };
    }
  };
}